import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import timeline from "../data/timeline.json";
import profileFoto from "../assets/img/profile-foto.webp";
import bookshelfImg from "../assets/about/bookshelf.png";
import photographyImg from "../assets/about/photography.png";
import vinylImg from "../assets/about/vinyl.png";

// swap `href` in for the real destinations when they exist
const stackFolders = ["rust", "verilog", "zk", "ros2"];

export const About = () => {
  const navigate = useNavigate();
  useDocumentTitle(
    "About — Arnav Panjla | Systems & Cryptography at IIT Delhi",
    "About Arnav Panjla: B.Tech EE'27 at IIT Delhi working on zero-knowledge proofs, privacy protocols, low-level systems programming and robotics."
  );

  // same navigate-then-scroll pattern the NavBar uses for in-page sections
  const goToSection = (id) => {
    navigate("/");
    requestAnimationFrame(() =>
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
    );
  };

  return (
    <section className="about-page">
      <Container>
        <div className="about-grid">
          <div className="about-bio">
            <h1>Hey, I'm Arnav!</h1>
            <p>
              I'm an undergrad at IIT Delhi who likes taking systems apart —
              embedded firmware, robotics stacks, and cryptographic protocols
              — to understand how they actually work, then building better
              versions of them.
            </p>
            <p>
              Most of my time goes into zero-knowledge proofs, privacy
              protocols, and low-level systems programming, with robotics as
              a long-running side interest from earlier in my degree.
            </p>
            <div className="about-timeline">
              {timeline.map((item) => (
                <div className="about-timeline-row" key={item.org}>
                  <span className="about-timeline-main">
                    <strong>{item.org}</strong>
                    <span className="about-timeline-sep"> / </span>
                    <span className="about-timeline-role">{item.role}</span>
                  </span>
                  <span className="about-timeline-years">{item.years}</span>
                </div>
              ))}
            </div>
            <a
              className="about-resume-link"
              href="https://drive.google.com/file/d/1jMW2yzuLjCC-TqBcjRuGv7ag6s6uBn08/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Resume →
            </a>
          </div>

          <div className="about-bento">
            <div className="about-bento-col">
              <div className="bento-card bento-portrait">
                <img src={profileFoto} alt="Arnav Panjla" />
              </div>

              <div className="bento-card bento-stack">
                <span className="bento-label">
                  STACK / 0{stackFolders.length} FOLDERS
                </span>
                <div className="bento-folders">
                  {stackFolders.map((name, i) => (
                    <div className="bento-folder" key={name}>
                      <span className="bento-folder-index">0{i + 1}</span>
                      <span className="bento-folder-name">{name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="about-bento-col">
              <button
                type="button"
                className="bento-card bento-library"
                onClick={() => goToSection("blogs")}
              >
                <span className="bento-media">
                  <img src={bookshelfImg} alt="" />
                </span>
                <span className="bento-label bento-label-light">BOOKSHELF</span>
                <span className="action-circle" aria-hidden="true">
                  →
                </span>
              </button>

              <a
                className="bento-card bento-playlist"
                href="https://open.spotify.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="bento-label">PLAYLIST</span>
                <span className="action-circle" aria-hidden="true">
                  ↗
                </span>
                <span className="bento-disk-wrap">
                  <img
                    className="bento-disk"
                    src={vinylImg}
                    alt=""
                    loading="lazy"
                    decoding="async"
                  />
                </span>
              </a>

              <button
                type="button"
                className="bento-card bento-photography"
                onClick={() => goToSection("blogs")}
              >
                <img
                  className="bento-photo"
                  src={photographyImg}
                  alt=""
                  loading="lazy"
                  decoding="async"
                />
                <span className="bento-scrim" aria-hidden="true" />
                <span className="bento-label bento-label-light">
                  RECENT PHOTOS
                </span>
                <span className="action-circle" aria-hidden="true">
                  →
                </span>
              </button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};
